import { FC } from 'react';
import { Modal } from 'components/Base/Modal';
import Spinner from 'components/Base/Spinner';
import { SMergeProgress, SWarningText } from '../../DuplicateMerge.styles';

type TMergeConfirmModalProps = {
  open: boolean;
  loading: boolean;
  entityToBeMergedLabel: string;
  onCancel: () => void;
  onConfirm: () => void;
};

const MergeConfirmModal: FC<TMergeConfirmModalProps> = ({
  open,
  loading,
  entityToBeMergedLabel,
  onCancel,
  onConfirm,
}) => {
  return (
    <Modal
      title="Merge Duplicates"
      open={open}
      onCancel={loading ? undefined : onCancel}
      onOk={onConfirm}
      okText="Merge"
      cancelText="Cancel"
      okButtonProps={{ danger: true, loading }}
      cancelButtonProps={{ disabled: loading }}
      closable={!loading}
      maskClosable={!loading}
    >
      <p>
        You will be merging history and data from entity to be merged into the
        entity that will remain.
      </p>
      <SWarningText>
        This cannot be undone. Once merged, {entityToBeMergedLabel} will be
        deleted and no longer exist in our database.
      </SWarningText>
      {loading && (
        <SMergeProgress>
          <Spinner spinnerSize={20} /> <span>Merging Records…</span>
        </SMergeProgress>
      )}
    </Modal>
  );
};

export default MergeConfirmModal;
